import { Component, OnInit } from '@angular/core';
import { BannerService, BannerDto } from './banner.service';
import { NotificationService } from '../../core/notification.service';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-banners-list',
  templateUrl: './banners-list.component.html',
  styleUrls: ['./banners-list.component.css']
})
export class BannersListComponent implements OnInit {
  loading = false;
  page = 1;
  pageSize = 20;
  total = 0;

  filtroNome = '';
  filtroLocalizacao = '';
  filtroAtivo = '';

  items: BannerDto[] = [];

  localizacoes = ['Home', 'Blog', 'Categoria'];

  constructor(private svc: BannerService, private notify: NotificationService, private router: Router) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.svc.list(this.page, this.pageSize).subscribe({
      next: (res: any) => {
        const data = res?.data ?? (Array.isArray(res) ? res : []);
        this.items = data.filter((b: BannerDto) =>
          (!this.filtroNome || (b.title || b.nome || '').toLowerCase().includes(this.filtroNome.toLowerCase())) &&
          (!this.filtroLocalizacao || (b.description || b.localizacao || '') === this.filtroLocalizacao) &&
          (!this.filtroAtivo || String(b.isActive ?? b.ativo ?? false) === this.filtroAtivo)
        );
        this.total = res?.meta?.total ?? this.items.length;
        this.loading = false;
      },
      error: (err) => {
        console.error('[Banners] erro ao listar', err);
        this.notify.showError('Erro ao carregar banners');
        this.loading = false;
      }
    });
  }

  resetFilters(): void {
    this.filtroNome = '';
    this.filtroLocalizacao = '';
    this.filtroAtivo = '';
    this.page = 1;
    this.load();
  }

  onPageChange(p: number) {
    this.page = p;
    this.load();
  }

  edit(item: BannerDto) {
    this.router.navigate(['/admin/config/banners', item.id, 'edit']);
  }

  remove(item: BannerDto) {
    if (!confirm(`Remover banner "${item.nome}"?`)) return;
    this.svc.delete(item.id).subscribe({
      next: () => {
        this.notify.showSuccess('Banner removido');
        this.load();
      },
      error: (err) => {
        console.error('[Banners] erro ao remover', err);
        this.notify.showError('Erro ao remover banner');
      }
    });
  }

  displayEnd(): number {
    const end = this.page * this.pageSize;
    return end > this.total ? this.total : end;
  }
}
